// https://www.npmjs.com/package/html-react-parser

import parse from 'html-react-parser';

const raw = (string) => parse(string);

export default raw;
